import React from "react";
import { CreateSalesAreaPriceLineDialog } from "../dialogs/CreateSalesAreaPriceLineDialog";
import { useDialog } from "../../../old/beheer/views/Upsell/modernTS/JUI/Dialogs";

export function useCreateSalesAreaPriceLine() {
  const { createDialog, closeDialog } = useDialog();

  return () => {
    return new Promise((resolve, reject) => {
      createDialog({
        name: "create-sales-area-price-line",
        maxWidth: "lg",
        children: (
          <CreateSalesAreaPriceLineDialog
            onCancel={() => {
              resolve("CANCELED");
              closeDialog("create-sales-area-price-line");
            }}
            onCreate={() => {
              resolve("CREATED");
              closeDialog("create-sales-area-price-line");
            }}
          />
        ),
      });
    });
  };
}
